import { render } from "./InquiryPage.vue?vue&type=template&id=04a25e0c"
import script from "./InquiryPage.vue?vue&type=script&lang=js"
export * from "./InquiryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__